import { render, staticRenderFns } from "./CollectionAccountTradeFlowModule.vue?vue&type=template&id=8016dd2a&scoped=true"
import script from "./CollectionAccountTradeFlowModule.vue?vue&type=script&lang=js"
export * from "./CollectionAccountTradeFlowModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8016dd2a",
  null
  
)

export default component.exports